import { Dispatch } from "react";
import API from "../../services/api";
import { Collection, CollectionFields, ContentStatus } from "typings";
import { createStatusMessage } from "../ui/StatusMessage";
import { statusAdd } from "../ui/action";
import { Action } from "redux";

export interface LoadCollectionAction
{
    type: "LOAD_COLLECTION_SUCCESS";
    collections: Collection[];
}

export interface CollectionDataUpdateAction
{
    type: "COLLECTION_DATA_UPDATE";
    id: string;
    data: CollectionFields;
}

export const collectionUpdate_ = (id: string, data: CollectionFields): CollectionDataUpdateAction => ({
    type: "COLLECTION_DATA_UPDATE", id, data
});
export interface DeleteCollectionAction
{
    type: "REMOVE_COLLECTION";
    id: string;
}

export const deleteCollection = (id: string) => async (dispatch: Dispatch<any>) =>
{
   
    try 
    {
        const action: DeleteCollectionAction = { type: "REMOVE_COLLECTION", id };
        dispatch(action);
        await API.collection.deleteCollection(id);
       
    }
    catch (e)
    {
        const statusFinished = createStatusMessage("Loading collections failed", "error", "product");
        dispatch(statusAdd(statusFinished));
    }
};

export const loadCollections = () => async (dispatch: Dispatch<any>) =>
{
   
    try 
    {
        const collections = await API.collection.getCollections();
        const action: LoadCollectionAction = { type: "LOAD_COLLECTION_SUCCESS", collections };
        dispatch(action);
    }
    catch (e)
    {
        const statusFinished = createStatusMessage("Loading collections failed", "error", "product");
        dispatch(statusAdd(statusFinished));
    }
};

export const loadCollection = (id: string) => async (dispatch: Dispatch<any>) =>
{
   
    try 
    {
        const collection = await API.collection.getCollection(id);
        const action: LoadCollectionAction = { type: "LOAD_COLLECTION_SUCCESS", collections: [collection] };
        dispatch(action);
    }
    catch (e)
    {
        const statusFinished = createStatusMessage("Loading collection failed", "error", "product");
        dispatch(statusAdd(statusFinished));
    }
};

export const changeCollectionName = (id: string, name: string) =>  async (dispatch: Dispatch<Action>) =>
{
    try 
    {
        const collection = await API.collection.changeCollectionName(id, name);
        const action: LoadCollectionAction = { type: "LOAD_COLLECTION_SUCCESS", collections: [collection] };
        dispatch(action);
    }
    catch (e)
    {
        const statusFinished = createStatusMessage("collection name change failed ", "error", "product");
        dispatch(statusAdd(statusFinished));
    }
   
};


export const updateCollectionStatus = (id: string, status: ContentStatus) => async (dispatch: Dispatch<Action>) =>
{   
      try
    {
        const collection = await API.collection.updateStatus(id, status);
        const action: LoadCollectionAction = { type: "LOAD_COLLECTION_SUCCESS", collections: [collection] };
        dispatch(action);
       
    } 
    catch (e)
    {
        const statusFinished = createStatusMessage("collection data update failed ", "error", "product");
        dispatch(statusAdd(statusFinished));
    }
};

export const updateCollectionData = (id: string, data: CollectionFields) => async (dispatch: Dispatch<Action>) =>
{   
  
    dispatch(collectionUpdate_(id, data));

    try
    {
        const collection = await API.collection.updateData(id, data);
        const action: LoadCollectionAction = { type: "LOAD_COLLECTION_SUCCESS", collections: [collection] };
        dispatch(action);
       
    } 
    catch (e)
    {
        const statusFinished = createStatusMessage("collection data update failed ", "error", "product");
        dispatch(statusAdd(statusFinished));
    }
};

export const setParentId = (id: string, parentId?: string) => async (dispatch: Dispatch<Action>) =>
{   
    try
    {
        const collection = await API.collection.setParentId(id, parentId);
        const action: LoadCollectionAction = { type: "LOAD_COLLECTION_SUCCESS", collections: [collection] };
        dispatch(action);
       
    } 
    catch (e)
    {
        const statusFinished = createStatusMessage("collection data update failed ", "error", "product");
        dispatch(statusAdd(statusFinished));
    }
};

export type CollectionActions = LoadCollectionAction | DeleteCollectionAction;



// WEBPACK FOOTER //
// ./src/state/collection/action.ts